const state = {
    channels: {},
    contacts: {},
    errors: {},
    formOpen: false,
    loadingChannels: false,
    loadingLogs: false,
    logInForm: {},
    logs: [],
    participant: {},
    reasons: {},
    statuses: {}
}

const getters = {
    //
}

const mutations = {
    setChannels (state, data) {
        return state.channels = data
    },
    setContacts (state, data) {
        return state.contacts = data
    },
    setReasons (state, data) {
        return state.reasons = data
    },
    setStatuses (state, data) {
        return state.statuses = data
    },
    setErrors (state, data) {
        return state.errors = data
    },
    setLoadingChannels (state, data) {
        return state.loadingChannels = data
    },
    setLoadingLogs (state, data) {
        return state.loadingLogs = data
    },
    setLogs (state, data) {
        return state.logs = data
    },
    setFormOpen (state, data) {
        return state.formOpen = data
    },
    setLogInForm (state, data) {
        return state.logInForm = data
    },
    setParticipant (state, data) {
        return state.participant = data
    },
    setUsers (state, data) {
        return state.users = data
    },
}

const actions = {
    closeForm(context) {
        context.commit("setFormOpen", false)
        context.commit("setErrors", {})
        context.commit("setLogInForm", {})
    },
    deleteLog(context, log) {
        if(confirm('You are about to delete a communications log. This cannot be undone. Are you sure you want to continue?')) {
            axios.delete('/api/comm-logs/' + log.id)
                .then(response => {
                    context.dispatch('fetchLogs', {'participant_id': state.participant.id});
                });
        }
    },
    fetchLogs(context, data) {
        context.commit("setLoadingLogs", true)
        axios.get('/api/comm-logs', {params: data})
        .then( (response) => {
            context.commit("setLogs", response.data.data)
            context.commit("setLoadingLogs", false)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchLogs(), "+ e.message)          
        })
    },
    fetchCommunicationReasons(context) {
        axios.get('/api/communication-reasons')
        .then( (response) => {
            context.commit("setReasons", response.data)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchCommunicationReasons(), "+ e.message)          
        })
    },
    fetchCommunicationStatuses(context) {
        axios.get('/api/communication-statuses')
        .then( (response) => {
            context.commit("setStatuses", response.data)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchCommunicationStatuses(), "+ e.message)          
        })
    },
    fetchContacts(context, data) {
        axios.get('/api/contacts', {params: data})
        .then( (response) => {
            context.commit("setContacts", response.data)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchContacts(), "+ e.message)          
        })
    },
    fetchContactChannels(context, contact_id) {
        context.commit("setLoadingChannels", true)
        let id = contact_id.split('_').pop()

        axios.get('/api/contacts/'+id+'/channels')
        .then( (response) => {
            context.commit("setChannels", response.data)
            context.commit("setLoadingChannels", false)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchContactChannels(), "+ e.message)          
        })
    },
    fetchParticipantChannels(context) {
        context.commit("setLoadingChannels", true)
        axios.get('/api/participants/'+state.participant.id+'/channels')
        .then( (response) => {
            context.commit("setChannels", response.data)
            context.commit("setLoadingChannels", false)
        })
        .catch( (e) => {
            console.log("Error: communications.js, fetchParticipantChannels(), "+ e.message)          
        })
    },
    saveCommLog(context, logData) {
        context.commit("setErrors", {})

        const {id, ...data} = logData

        let url = '/api/comm-logs'
        let fd = new FormData()
        Object.keys(data).forEach(key => fd.append(key, data[key]))

        if (id) {
            url = [url, id].join('/')
            fd.append('_method', 'PATCH')
        }

        axios.post(url, fd)
            .then((response) => {
                context.dispatch('fetchLogs', {'participant_id': state.participant.id})
                context.dispatch('closeForm')
            }).catch((e) => {
                context.commit("setErrors", e.response.data.errors)
            })
    },
    setFormOpen(context, data) {
        context.commit("setFormOpen", data)
    },
    setLogInForm(context, data) {
        context.commit("setLogInForm", data)
    },
    setContacts(context, data) {
        context.commit("setContacts", data)
    },
    setParticipant(context, data) {
        context.commit("setParticipant", data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}